<!--
 * @LastEditors: Yx
 * @LastEditTime: 2022-08-01 14:15:46
 * @Description: 
 * @Author: Yx
 * @Date: 2022-07-20 16:44:32
 * @FilePath: \szjzsoft-framework\src\components\publicTemplate\index.vue
-->
<template>
  <el-row>
    <el-col>
      <div class="wrp">
        <div class="topShow" v-if="topShow">
          <slot name="topShow"></slot>
        </div>
        <div class="mainHeader" v-if="mainTabs">
          <slot name="mainTabs"></slot>
        </div>
        <div class="mainBody" v-if="mainBody">
          <slot name="mainBody"></slot>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: "publicTem",
  props: {
    topShow: {
      // 头部图片是否显示
      type: Boolean,
      default: true,
    },
    mainTabs: {
      // 标签导航是否显示
      type: Boolean,
      default: true,
    },
    mainBody: {
      // 主表内容是否显示
      type: Boolean,
      default: true,
    },
  },
};
</script>
